import React, { useEffect, useMemo } from 'react';
import {connect,  useDispatch, useSelector  } from 'react-redux';
import { change, FieldArray, reduxForm, reset } from 'redux-form';
import { inviteUser } from '../CollaboratorPage/shared';
import { workspace_userActions, multi_userActions } from '../../../actions';
import { Button } from 'react-bootstrap';
import { workspaceUserValidaton } from '../../../shared/form-validations';
import { userConstants } from '../../../constants';

function SingleInviteForm(props) {
  const { handleSubmit, initialData, initialize, invalid } = props
  const {
    workspaceId,
    getCommonData,
    usersList,
    resentInviteUser,
    suggested_emails,
    user_form
  } = props
  const dispatch = useDispatch();
  const workspace = useSelector(state => state.workspaceUser.currentWorkSpace);
  const workspace_user_error = useSelector(state => state.workspaceUser);
  const invited_user_email = user_form?.values?.invited_users[0]?.email || '';

  const setInitialCommonData = getCommonData
  const inviteUserList = resentInviteUser

  useEffect(() => {
    const loading = false;

    dispatch(workspace_userActions.getWorkspaceData(workspaceId));
    dispatch(multi_userActions.getAllUsrs(workspaceId, loading));
    initialize({workspace_users: [{ workspace_id: workspaceId}], invited_users: ['']});
  }, []);

  const onSubmit = (values) => {
    let successCallback = () => {
      dispatch(reset('userform'));
    }

    dispatch(workspace_userActions.createWorkspaceUser(workspaceId, values, successCallback));
  }

  const deleteListItemAction = (id) => {
    const suggestion_id = id;
    const onSuccess = (response) => {
      const { data } = response;

      dispatch({ type: userConstants.REMOVE_EMAIL_SUGGESTION, payload: data })
    }
    dispatch(workspace_userActions.deleteEmailSuggestion({ suggestion_id, onSuccess }));
  }

  const selectListItem = (id) => {
    const selected_item = suggested_emails.find(item => item.id === id);

    if(selected_item){
        const invitedUsers = user_form?.values?.invited_users || [];

        let newInvitedUsers;

        if (invitedUsers.length === 0) {
          newInvitedUsers = [{ email: selected_item.value }];
        } else {
          newInvitedUsers = [
            { ...invitedUsers[0], email: selected_item.value },
            ...invitedUsers.slice(1)
          ];
        }

        dispatch(change('userform', 'invited_users', newInvitedUsers));
    }
  }
  

  const filteredSuggestions = useMemo(() => {
    if (!invited_user_email) return suggested_emails;

    const q = invited_user_email.toLowerCase();

    return suggested_emails.filter(suggestion =>
      suggestion.value.toLowerCase().includes(q)
    );
  }, [suggested_emails, invited_user_email]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex justify-content-between" style={{ columnGap: "1rem" }}>
        <FieldArray
          name='invited_users'
          component={inviteUser}
          change={props.change}
          roles={setInitialCommonData && setInitialCommonData}
          listData={filteredSuggestions}
          deleteListItemAction={deleteListItemAction}
          selectListItem={selectListItem}
        />

        <Button 
          variant="success" 
          type="submit" 
          className="fw-500" 
          disabled={ invalid } 
          size={'sm'}
          style={{ minWidth: "100px" }}
        >
          Invite
        </Button>
      </div>
    </form>
  );
}

SingleInviteForm =  reduxForm({
  form: 'userform',
  validate: workspaceUserValidaton
})(SingleInviteForm);

const mapStateToProps = (state) => {
  return {
    loading: state.workspaceUser.loading,
    initialData: state.workspaceUser.workspaceInitialData,
    currentWorkSpace: state.work_space.currentWorkSpace,
    getCommonData: state.dashboard.getCommonData,
    usersList: state.multiUser.allUsers,
    remaining_users: state.organization.remaining_users,
    ignore_limit: state.organization.ignore_limit,
    error: state.workspaceUser.error,
    current_organization: state.organization.current_organization,
    suggested_emails: state.workspaceUser.suggested_emails,
    user_form: state.form.userform
  };
};

export default connect(mapStateToProps,{ workspace_userActions })(SingleInviteForm);
